import ApiConfig from "../../Utils/Configs/apiConfig";
export const GetBusinessClientsService = async () => {
  // return ApiConfig.getInstance().get("/businessclients");
  try {
    //const response = await axios.get("http://localhost:3020/businessclients");
    const response = await ApiConfig.getInstance().get(
      "/BusinessClient/get-all-businessclient"
    );

    //const filterOnlyUsers = response.data.data.filter((role)=>{role.roleId === 1});

    return response.data.data;
  } catch (error) {
    console.error(error);
    return [];
  }
};

export const GetClientOverviewService = async (userId: string) => {
  try {
    const response = await ApiConfig.getInstance().get(
      `/BusinessClient/get-client-overview/${encodeURIComponent(userId)}`
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching client overview:", error);
    return null;
  }
};



export const GetBusinessClientSortService = async (payload: {
   sortBy: string,
  sortOrder: "asc" | "desc"
  searchTerm: string
}) => {
  try {
    const response = await ApiConfig.getInstance().post(
      "/BusinessClient/businessclients/sort", payload
    )

  if (response.status !== 200) {
      throw new Error("Failed to fetch sorted business clients");
    }
    return response.data.data;
  } catch (error) {
    console.error("Error fetching sorted business clients:", error);
    return [];
  }
}

export const ResendInviteService = async (clientId: string) => {
  try {
    const response = await ApiConfig.getInstance().post(
      `/BusinessClient/resend-invite?clientId=${clientId}`
    );

    return response.data;
  } catch (error) {
    console.error(error);
    return null;
  }
};

//Invite_user_service
export const ResentInviteServiceUser = async (userId: string) => {
  try {
    const response = await ApiConfig.getInstance().post(
      `/User/${userId}/resend-invite`
    );

    return response.data;
  } catch (error) {
    console.error(error);
    return null;
  }
};
 


// User Management Services
export const getUsersSortedBy = async (payload: {}) => {
  try {

    /*
         id: 1,
      firstname: "John",
      lastname: "kay",
      name: "John kay",
      email: "johnkay@iykons.com",
      role: "Admin",
      clients: "",
      status: "Active",
      lastActive: "21 May 2025 10:40 AM",*/
    const response = await ApiConfig.getInstance().get(
      "/UserProfile/get-all-UserDetails-ByAdmin"
    )

  if (response.status !== 200) {
      throw new Error("Failed to fetch sorted users");
    } 
    return response.data.map((user: any, index: number) => {
      return {
        id: index + 1,
        // The real backend id, kept separate from the table's synthetic
        // `id` (index + 1) above — EditUserService needs this to know which
        // user to update.
        userId: user.userId ?? user.id,
        firstname: user.firstName,
        lastname: user.lastName,
        name: `${user.firstName} ${user.lastName}`,
        email: user.email,
        role: user.roleName,
        clients: user.clientName || "",
        status: user.isActive ? "active" : "pending",
        lastActive: new Date(user.lastLogin).toLocaleString("en-US", {
          day: "2-digit",
          month: "short",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        }),
      }
    })
    // return response.data;
  } catch (error) {
    console.error("Error fetching sorted users:", error);
    return [];
  }
}